<template>
  <div class="irp-activity-tab" data-testid="irp-activity-tab">
    <IRPActivityTimeline
      :source-id="sourceId"
      :source-primary-key="sourcePrimaryKey"
      :account-name="individualRecordStore.recordName"
    />
  </div>
</template>

<script setup lang="ts">
import IRPActivityTimeline from '@/components/records/IRPActivityTimeline.vue';

import { useIndividualRecordStore } from '@/stores';

type Props = {
  sourceId: number;
  sourcePrimaryKey: string;
};

defineProps<Props>();

const individualRecordStore = useIndividualRecordStore();
</script>
